<div class="dashboard max-w-[100vw] overflow-hidden">
  <div class="layout-1">
    <div class="header flex flex-row items-center">
      <div class="left-head w-1/2">
        <div class="logo-home flex flex-row items-center gap-6">
          <img src="/emc.png" alt="" class="logo h-24 w-52" />
          <span class="text title font-semibold">PROJECT DASHBOARD</span>
        </div>
      </div>
      <div class="right-head w-1/2 flex flex-row gap-6 justify-end">
        <div class="project-count right-item flex justify-center">
          @if (totalProject) {
            <span class="text count font-bold">{{ totalProject }}</span>
          } @else {
            <i class="pi pi-spin pi-spinner !text-5xl"></i>
          }
          <span class="text">PROJECTS</span>
        </div>
        <div class="time right-item">
          <span class="text count">{{
            time$ | async | date: "EEE d MMM, h:mm:ss a"
          }}</span>
          <!-- {{ viewportWidth }} - {{ viewportHeight }} - {{ dpr }} -->
        </div>
        <p-button
          (onClick)="visible = true"
          [styleClass]="'!bg-blue-400 !border-blue-500'"
        >
          <svg
            class="h-14 w-14"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 19C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V3C0 2.45 0.195833 1.97917 0.5875 1.5875C0.979167 1.19583 1.45 1 2 1H10V3H2V17H16V10H18V17C18 17.55 17.8042 18.0208 17.4125 18.4125C17.0208 18.8042 16.55 19 16 19H2ZM3 15H15L11.25 10L8.25 14L6 11L3 15ZM15 8V3.825L13.4 5.4L12 4L16 0L20 4L18.6 5.4L17 3.825V8H15Z"
              fill="white"
            />
          </svg>
        </p-button>
        <p-button styleClass="!py-4 !px-5 !bg-gray-700 !border-gray-400" (click)="logout()">
          <i class="pi pi-sign-in !text-4xl"></i>
        </p-button>
      </div>
    </div>
    <div class="body">
      <div class="data-group">
        <p-carousel
          [value]="projectStack"
          [numVisible]="1"
          [numScroll]="1"
          orientation="vertical"
          [autoplayInterval]="40000"
          verticalViewPortHeight="100vh"
          [indicatorsContentStyle]="{
            position: 'fixed',
            top: '5rem',
            left: '45vw',
          }"
          [showNavigators]="false"
        >
          <ng-template let-project #item>
            <div class="data-group px-10 grid grid-cols-3 gap-12">
              @if (project[0]) {
                <emc-section-item [project]="project[0]"></emc-section-item>
              }
              @if (project[1]) {
                <emc-section-item [project]="project[1]"></emc-section-item>
              }
              @if (project[2]) {
                <emc-section-item [project]="project[2]"></emc-section-item>
              }
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Change background image"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '45vw', fontSize: '2.7rem', paddingLeft: '1.2rem', paddingRight: '1.2rem' }"
>
  <span class="p-text-secondary block mb-8 ">Please upload images with a minimum resolution of 1920x1080 pixels in PNG or JPG format.</span>
  <div class="flex items-center gap-4 mb-8">
    <input pInputText class="flex-auto" autocomplete="off" placeholder="Paster URL of image" [(ngModel)]="bgUrl" />
  </div>
  <div class="flex justify-end gap-2">
    <p-button styleClass="!text-4xl !py-5 !px-9" label="Cancel" severity="secondary" (click)="visible = false" />
    <p-button styleClass="!text-4xl !py-5 !px-9 !bg-blue-400 !border-blue-500" label="Save" (click)="changeBackground()" />
  </div>
</p-dialog>
